import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js';

//import { STRIPE_KEY } from '@constants';

import { handleError } from './errorHandler';

const stripeRetryLSKey = 'stripe-retry-seconds';

// NOTE: this workaround is needed because of poor error handling around Stripe loading
// See: https://github.com/stripe/stripe-js/issues/26#issuecomment-1477716731
export const getStripePromise = (stripeKey: string) =>
  (async () => {
    if (typeof window === 'undefined') {
      return null;
    }
    try {
      const result = await loadStripe(stripeKey);
      localStorage.removeItem(stripeRetryLSKey);
      return result;
    } catch (error) {
      const retrySeconds = Number(localStorage.getItem(stripeRetryLSKey)) || 5;
      handleError(error, {
        tags: {
          nextReloadDelay: String(retrySeconds),
        },
      });
      setTimeout(() => {
        const tip =
          retrySeconds > 5
            ? `Make sure you don't have browser extensions blocking 3rd party cookies or scripts or try it in another browser. `
            : ' ';
        const errorMessage = `We use Stripe for taking payments but it failed to load now. ${tip}To retry we'll reload the app in ${retrySeconds} seconds...`;
        alert(errorMessage);
      }, 500);
      if (process.env.NODE_ENV === 'development') {
        return null;
      }
      setTimeout(() => {
        window.location.reload();
      }, retrySeconds * 1000);
      const nextRetryDelay =
        retrySeconds <= 20 ? 2 * retrySeconds : retrySeconds;
      localStorage.setItem(stripeRetryLSKey, String(nextRetryDelay));
      return null;
    }
  })();

export const getStripeOptions = (
  clientSecret: string,
  event: IEvent,
  eventSeries?: IEventSeries
): StripeElementsOptions => ({
  clientSecret,
  appearance: {
    theme: 'stripe',
    labels: 'floating',
    variables: {
      fontFamily: ' "Basier Square", sans-serif',
      borderRadius: '16px',
      colorBackground: eventSeries?.ColourBackground ?? event.ColourBackground,
      colorText: eventSeries?.SystemColour ?? event.SystemColour,
      colorPrimary: eventSeries?.ColourSecondary ?? event.ColourSecondary,
      colorIcon: eventSeries?.ColourSecondary ?? event.ColourSecondary,
      colorDanger: eventSeries?.ColourPrimary ?? event.ColourPrimary,
      fontWeightNormal: '500',
      fontSizeBase: '16px',
    },
    rules: {
      '.Input': {
        borderWidth: '2px',
        padding: '15px 20px',
        outline: 'none',
        transition: 'all 0.2s linear',
        fontWeight: '500',
      },
      '.Input:hover': {
        boxShadow: 'none',
        borderColor: 'var(--colorPrimary)',
      },
      '.Input:focus': {
        boxShadow: 'none',
        borderColor: 'var(--colorSystem)',
      },
      '.Label': {
        color: 'var(--colorPrimary)',
        opacity: '1',
      },
      '.Label--floating': {
        color: 'var(--colorPrimary)',
        opacity: '1',
        paddingBottom: '5px',
      },
      '.Input::placeholder': {
        color: 'rgba(0,0,0,0)',
        fontSize: '0px',
      },
    },
  },
});
